import React, { useState, useEffect } from 'react';
import ItemSelector from "../../../../../components/controls/itemSelector.jsx";

export default function FullHistoryFilters({ dataRule, fullHistoryFilters, ruleChanged }) {
    const [items, setItems] = useState([]);

    useEffect(() => mountProperties(), [dataRule, fullHistoryFilters]);

    return <div className="dm-container dm-no-padding">
        <ItemSelector
            items={items}
            selectedItemsChanged={selectedItemsChanged} />
    </div>;

    function mountProperties() {
        if (!dataRule || !fullHistoryFilters) {
            setItems([]);
            return;
        }

        let fullHistoryFiltersList = Array.isArray(fullHistoryFilters) && fullHistoryFilters.length ? fullHistoryFilters : [];
        fullHistoryFiltersList.forEach(i => i.isSelected = dataRule.fullHistoryFilters.some(id => id == i.id));

        setItems(fullHistoryFiltersList);
    }

    function selectedItemsChanged(selectedItems) {
        if (ruleChanged)
            ruleChanged({
                ...dataRule,
                fullHistoryFilters: selectedItems ? selectedItems.map(i => i.id) : [],
                isUpdated: true
            });
    }
}